export enum ServiceTypesActionTypes {
  SET = "SERVICE_TYPES/SET",
}
